module.exports = __webpack_public_path__ + "static/media/biased.2070aea5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/biased.jpg
// module id = 83
// module chunks = 0